// src/components/HeroSection.js

import React from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';
import { FaPhone, FaFileAlt } from 'react-icons/fa';

function HeroSection() {
  return (
    <section className="hero">
      <div className="hero-background"></div>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-title">
          Voyagez avec <span className="hero-highlight">TaxiVD</span>
        </h1>
        <p className="hero-subtitle">
          Votre partenaire de confiance pour tous vos déplacements dans la région vaudoise
        </p>
        <div className="hero-buttons">
          <a href="tel:+41797774444" className="hero-button hero-button-secondary">
            <FaPhone className="phone-icon" /> +41 79 777 44 44
          </a>
          <Link to="/quote" className="hero-button hero-button-primary">
            <FaFileAlt className="quote-icon" /> Demander un devis
          </Link>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
